import type { TemplateOnlyComponent } from '@ember/component/template-only';

/**
 * Layout wrapper for the Component Library section.
 * Renders the active sub-route (index, select, drawer, etc.) via {{outlet}}.
 */
const ComponentsLayout: TemplateOnlyComponent = <template>{{outlet}}</template>;

export default ComponentsLayout;
